import { useEffect, useRef, useState, useCallback, useContext } from "react";
import { AuthContext } from "../../context/Auth/AuthContext";

const IDLE_TIMEOUT_MS = 5 * 60 * 1000; // 5 minutos de inatividade

const useIdleTimer = (timeoutMs = IDLE_TIMEOUT_MS) => {
  const { user, isAuth, socket } = useContext(AuthContext);
  const [isIdle, setIsIdle] = useState(false);
  const timerRef = useRef(null);
  const isIdleRef = useRef(false);

  const setIdleState = useCallback(
    (idle) => {
      if (isIdleRef.current === idle) return;
      isIdleRef.current = idle;
      setIsIdle(idle);

      if (socket && isAuth && user) {
        socket.emit("user:setIdle", idle);
      }
    },
    [socket, isAuth, user]
  );

  const resetTimer = useCallback(() => {
    // Se estava ocioso e houve interação física, volta para ativo
    if (isIdleRef.current) {
      setIdleState(false);
    }

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(() => {
      setIdleState(true);
    }, timeoutMs);
  }, [setIdleState, timeoutMs]);

  useEffect(() => {
    if (!isAuth || !user) {
      if (timerRef.current) clearTimeout(timerRef.current);
      return;
    }

    const events = [
      "mousemove",
      "mousedown",
      "keydown",
      "touchstart",
      "scroll",
      "wheel"
    ];

    const handleVisibilityChange = () => {
      if (document.hidden) {
        // Se a aba foi minimizada / oculta, acelera o timer ou aguarda
      } else {
        resetTimer();
      }
    };

    const handleActivity = () => {
      resetTimer();
    };

    events.forEach((event) => {
      window.addEventListener(event, handleActivity, { passive: true });
    });
    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Iniciar contagem
    resetTimer();

    return () => {
      events.forEach((event) => {
        window.removeEventListener(event, handleActivity);
      });
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [isAuth, user, resetTimer]);

  return { isIdle };
};

export default useIdleTimer;
